<template lang="pug">
    #customer-info
        v-banner.title-banner(min-height="88")
            .text-h4.font-weight-bold {{$t('Menu.__Sales')}} : {{editType==1?$t('Customers.__AddCustomer'): $t('Customers.__EditCustomer')}}
            template(v-slot:actions)
                v-btn.ml-6(rounded, dark color="#b4b9be" @click="$router.go(-1)") {{ $t('ActionOption.__Cancel') }}
                v-btn.ml-6(rounded color="primary" @click="saveEdit")  {{$t('ActionOption.__Save')}}
        v-container.slim-container
            Alert
            v-form.2sumup(v-if="editType == 1" v-model="displayIdValid" ref="displayidform")
                .field-label 
                    span {{$t('Customers.__SearchNote')}}
                v-text-field(v-model="sumupid" solo dense outlined :rules="[rules.numberAndLetters, rules.length6to12, rules.isNotOwnDisplayId]")
                    template(v-slot:append-outer)
                        v-btn(rounded color="primary" style="top: -7px; width:112px" @click="searchDisplayId(sumupid)") {{$t('ActionOption.__Search')}}
            v-form(v-model="formValid" ref="customerform")
                .customer-info
                    .sub-title.mb-10 {{$t('ContactInfo.__ContactInfo')}}
                    .field-label 
                        span {{$t('ContactInfo.__CustomerName')}}
                        span.required *
                    v-text-field(v-model="customer.name" solo dense outlined required :rules="[rules.required]" :disabled="isLocked")
                    .field-label 
                        span Email
                        //- span.required *
                    v-text-field(v-model="customer.email" solo dense outlined required :rules="[rules.email]")
                    .field-label 
                        span  {{$t('ContactInfo.__Tel')}}
                    v-text-field(v-model="customer.phone" solo dense outlined )
                    .field-label 
                        span {{$t('ContactInfo.__Fax')}}
                    v-text-field(v-model="customer.fax" solo dense outlined  )
                    .field-label 
                        span {{$t('ContactInfo.__AccountNumber')}}
                    v-text-field(v-model="customer.accountNumber" solo dense outlined)
                    .field-label 
                        span {{$t('ContactInfo.__BankName')}}
                    v-text-field(v-model="customer.bankName" solo dense outlined  )
                    .field-label 
                        span {{$t('ContactInfo.__BankAddress')}}
                    v-text-field(v-model="customer.bankAddress" solo dense outlined  )
                    .field-label 
                        span {{$t('ContactInfo.__SwiftCode')}}
                    v-text-field(v-model="customer.bankSwiftCode" solo dense outlined  )
                    .field-label 
                        span {{$t('ContactInfo.__Website')}}
                    v-text-field(v-model="customer.website" solo dense outlined placeholder="http(s)://example.com"  )
                    .field-label 
                        span {{$t('ContactInfo.__TaxID')}}
                    v-text-field(v-model="customer.taxId" solo dense outlined )
                    .field-label 
                        span {{$t('ContactInfo.__Memo')}}
                    v-textarea(v-model="customer.memo" solo outlined height="80")
                v-divider.my-10
                .bill-info
                    .sub-title.mb-10 {{$t('ContactInfo.__BillingInfo')}}
                    //- .field-label 
                    //-     span 貨幣別
                    //-     span.required *
                    //- CurrencySelector(v-model="customer.billingCurrencyCode" :rules="[rules.required]" )
                    .field-label 
                        span {{$t('ContactInfo.__Country')}}
                    CountrySeletor(v-model="customer.billingCountryCode" )
                    .field-label 
                        span {{$t('ContactInfo.__ZIPCode')}}
                    v-text-field(v-model="customer.billingPostalCode" solo dense outlined required )
                    .field-label 
                        span {{$t('ContactInfo.__BillingAddress')}}
                    v-text-field(v-model="customer.billingAddress" solo dense outlined required )
                    v-text-field(v-model="customer.billingAddress2" solo dense outlined)
                v-divider.my-10
                .sub-title.mb-10 {{$t('ContactInfo.__ShippingInfo')}}
                v-checkbox(v-model="isSameAsBilling" :label="$t('ContactInfo.__SameAsBilling')")
                .ship-info(v-if="!isSameAsBilling")
                    .field-label 
                        span {{$t('ContactInfo.__ShippingName')}}
                    v-text-field(v-model="customer.shippingRecipient" solo dense outlined required)
                    .field-label 
                        span {{$t('ContactInfo.__Country')}}
                    CountrySeletor(v-model="customer.shippingCountryCode")
                    .field-label 
                        span {{$t('ContactInfo.__ZIPCode')}}
                    v-text-field(v-model="customer.shippingPostalCode" solo dense outlined required )
                    .field-label 
                        span {{$t('ContactInfo.__ShippingAddress')}}
                    v-text-field(v-model="customer.shippingAddress" solo dense outlined required )
                    v-text-field(v-model="customer.shippingAddress2" solo dense outlined)

                .field-label 
                    span {{$t('ContactInfo.__ShippingMemo')}}
                v-textarea(v-model="customer.shippingMemo" solo outlined height="80")

</template>
<script>
import * as textfieldUtils from "@/utils/textfield.js"
import * as unsaveNotify from "@/utils/unsaveNotify.js"

export default {
  mixins: [unsaveNotify.mixin],
  components: {},
  data() {
    return {
      sumupid: "",
      isLocked: false,
      formValid: false,
      displayIdValid: false,
      rules: textfieldUtils.rules,
      editType: 1,
      isSameAsBilling: false,
      cid: 0,
      customer: {
        name: "",
        email: ""
      }
    }
  },
  methods: {
    getCustomer(id) {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("customers/getCustomer", id)
        .then(
          function(response) {
            this.customer = response.data
            if (this.customer.relatedBusiness != null) {
              this.isLocked = true
            }
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    getBiz(id) {
      if (id == null || id == "") {
        this.$store.dispatch("global/showAlertError", "please enter Id for searching")
      } else {
        this.$store.dispatch("global/closeAlert")
        this.$store.dispatch("global/startLoading")
        this.$store
          .dispatch("bizes/getBiz", id)
          .then(
            function(response) {
              this.customer = response.data
              this.isLocked = true
              this.customer.relatedBusinessId = this.customer.id
              this.$store.dispatch("global/stopLoading")
              this.$refs.customerform.resetValidation()
            }.bind(this)
          )
          .catch(
            function(error) {
              this.$store.dispatch("global/stopLoading")
              this.$store.dispatch("global/showAlertError", error.message)
            }.bind(this)
          )
      }
    },
    searchDisplayId(id) {
      this.$refs.displayidform.validate()
      if (this.displayIdValid) {
        this.getBiz(id)
      }
    },
    saveEdit() {
      this.$refs.customerform.validate()
      if (this.formValid) {
        if (this.editType == 1) {
          this.createCustomer()
        } else {
          this.updateCustomer()
        }
      }
    },
    createCustomer() {
      this.$store.dispatch("global/startLoading")
      this.updateShippingInfo()
      this.$store
        .dispatch("customers/createCustomer", this.customer)
        .then(
          function(response) {
            this.savedTag = true
            this.$router.push({
              name: "Customers",
              params: {
                alert: {
                  message: this.$t("Messages.__SuccessfullyCreated"),
                  type: "success"
                }
              }
            })
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/stopLoading")
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
    },
    updateCustomer() {
      this.$store.dispatch("global/startLoading")
      this.updateShippingInfo()
      this.$store
        .dispatch("customers/updateCustomer", this.customer)
        .then(
          function(response) {
            this.savedTag = true
            this.$router.push({
              name: "Customers",

              params: {
                alert: {
                  message: this.$t("Messages.__SuccessfullyUpdated"),
                  type: "success"
                }
              }
            })
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/stopLoading")
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
    },
    updateShippingInfo() {
      if (this.isSameAsBilling) {
        ;(this.customer.shippingPostalCode = this.customer.billingPostalCode),
          (this.customer.shippingAddress = this.customer.billingAddress),
          (this.customer.shippingRecipient = this.customer.name),
          (this.customer.shippingCountryCode = this.customer.billingCountryCode)
      }
    }
  },
  created() {
    if (this.$route.name == "CustomerNew") {
      this.editType = 1
    } else {
      this.cid = this.$route.params.cid
      this.editType = 2
      this.getCustomer(this.cid)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/formcontrol.scss";
</style>
